// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__lh9VQ","pulse":"styles_pulse__4sdLW","jump":"styles_jump__EIbv3"};